var getValidationRules = function (t) {

  return {
    rules: {
      password: {
        required: true,
        maxlength: 256
      },
      confirmPassword: {
        required: true,
        maxlength: 256,
        equalTo: "#Password"
      },
      terms: {
        required: true
      }
    },

    messages: {
      password: {
        required: t('Please enter %s', {
          context: 'validation',
          postProcess: 'sprintf',
          sprintf: [t('Password')]
        }),
        maxlength: t('Max length of %s is %d characters', {
          context: 'validation',
          postProcess: 'sprintf',
          sprintf: [t('Password'), 256]
        })
      },
      confirmPassword: {
        required: t('Please enter %s', {
          context: 'validation',
          postProcess: 'sprintf',
          sprintf: [t('Confirm password')]
        }),
        maxlength: t('Max length of %s is %d characters', {
          context: 'validation',
          postProcess: 'sprintf',
          sprintf: [t('Confirm password'), 256]
        }),
        equalTo: t('Passwords must be equals', {context: 'validation'})
      },
      terms: {
        required: t('You must accept terms and conditions', {context: 'validation'})
      }
    },

    errorPlacement: function (error, element) {
      var wrapper = $(element).parent('label.checkbox');

      if (wrapper.length) {
        error.insertAfter(wrapper);
      } else {
        error.insertAfter(element);
      }
    }
  }

};


module.exports = getValidationRules;
